import Icon from '../components/Icon.vue'

Icon.register({
  splotch: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M472.3 195.9L405.2 172.9C386 166.3 371.7 152 367.1 134.6L351.1 74.2C339.5 30.4 274.5 17.1 241.1 51.6L195 99.2C181.7 112.9 161.4 120.2 140.8 118.6L68.9 112.9C16.9 108.9-18 157.8 9.9 195.8L48.4 248.2C59.5 263.3 61.2 282 53 298.4L24.6 355.4C4 396.6 47.5 440.3 98.1 429.2L168.1 413.9C188.2 409.5 209.5 413.9 225.1 425.7L279.5 466.5C318.8 496.1 380.5 474.1 383.9 429.3L388.6 367.4C390 349.6 401.4 333.5 419.2 324.4L481.2 292.7C526.1 269.7 520.8 212.5 472.3 195.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/splotch.js
// module id = rW2a
// module chunks = 144